/**
 * City picker options. Values are core `cities.id` (prod 2026-11-03: 1 Baghdad, 6 Basra,
 * 15 Arbeel/Erbil; 2 is Karbala and 3 is Babel, which four pages used to label Basra and Erbil).
 */
export const CITIES = [
  { value: 1, label: 'Baghdad' },
  { value: 6, label: 'Basra' },
  { value: 15, label: 'Erbil' },
];
